import React from 'react'
import ModalFormUI from '../../../../widgets/form/ModalFormUI'
import InputTextSF from '../../../../widgets/form/InputTextSF'
import InputSelectSF from '../../../../widgets/form/InputSelectSF'
import InputDateUI from '../../../../widgets/form/InputDateUI'

const InternalStatusModalUI = ({
  context, selectedFileCode, successMsg, errorList, setErrorList,
  updateMode, submitted, onSubmit, onCancelClick,
  internalStatus, onInternalStatusChange, internalStatusError, setInternalStatusError, internalStatusList,
  internalMessage, onInternalMessageChange, internalMessageError, setInternalMessageError,
  dueDate, onDueDateChange, dueDateError, setDueDateError,
  cureDate, onCureDateChange, cureDateError, setCureDateError,
  alertIntervalDays, onAlertIntervalDaysChange, alertIntervalDaysError, setAlertIntervalDaysError,
  nextDueDate, onNextDueDateChange, nextDueDateError, setNextDueDateError,
  fileName, onFileNameChange, fileNameError, setFileNameError
}) =>
  <ModalFormUI
    context={context}
    titleLabel='Status'
    buttonLabel='Update'
    cancelLabel='Cancel'
    isOpen={updateMode}
    onRequestClose={onCancelClick}
    successMsg={successMsg}
    errorList={errorList}
    setErrorList={setErrorList}
    onSubmit={onSubmit}
    busy={submitted}
  >

    < InputSelectSF type='select' name='status' label='Internal Status'
      required={true}
      value={internalStatus} onChange={onInternalStatusChange} optionList={internalStatusList}
      error={internalStatusError} setError={setInternalStatusError}
    />

    <InputTextSF type='text' name='internalMessage' label='Internal message'
      maxLength={100}
      value={internalMessage} onChange={onInternalMessageChange}
      error={internalMessageError} setError={setInternalMessageError}
    />

    {
      internalStatus === 'not_complied' &&
      <>
        <InputDateUI type='date' name='dueDate' label='Due date'
          context={context}
          selectedDateISO={dueDate} onChange={onDueDateChange}
          error={dueDateError} setError={setDueDateError}
          help='Defaulted to disbursement date + 15 days'
        />

        {/* <InputTextSF type='text' name='alertIntervalDays' label='Alert interval days'
          value={alertIntervalDays} onChange={onAlertIntervalDaysChange}
          error={alertIntervalDaysError} setError={setAlertIntervalDaysError}
        /> */}
      </>
    }

    {
      internalStatus === 'complied' &&
      <>
        <InputDateUI type='date' name='cureDate' label='Cure date'
          context={context}
          selectedDateISO={cureDate} onChange={onCureDateChange}
          error={cureDateError} setError={setCureDateError}


        />
      </>
    }

    {/* {
      internalStatus === 'complied' &&
      <>
        <InputDateUI type='date' name='nextDueDate' label='Next due date'
          context={context}
          selectedDateISO={nextDueDate} onChange={onNextDueDateChange}
          error={nextDueDateError} setError={setNextDueDateError}
        />
      </>
    } */}

    {
      (selectedFileCode === 'cp_other' || selectedFileCode === 'cs_other') &&
      <InputTextSF type='text' name='fileName' label='File name'
        required={true} maxLength={100}
        value={fileName} onChange={onFileNameChange}
        error={fileNameError} setError={setFileNameError}
      />
    }

  </ModalFormUI>

export default InternalStatusModalUI
